"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var apollo_link_retry_1 = require("apollo-link-retry");
function createRetryLink() {
    return new apollo_link_retry_1.RetryLink({
        delay: {
            initial: 300,
            max: Infinity,
            jitter: true,
        },
        attempts: {
            max: 5,
            retryIf: function (error) { return !!error; },
        },
    });
}
exports.createRetryLink = createRetryLink;
//# sourceMappingURL=createRetryLink.js.map